import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import CalendarComp from '../../CalendarComp/CalendarComp';

const MonthBarChart = () => {
  // Sample data for the bar chart
  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: 'Wallet Payment',
        backgroundColor: 'rgba(255,99,132,0.6)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255,99,132,0.8)',
        hoverBorderColor: 'rgba(255,99,132,1)',
        data: [30, 35, 40, 45, 50, 55],
      },
      {
        label: 'Promo Payment',
        backgroundColor: 'rgba(54,162,235,0.6)',
        borderColor: 'rgba(54,162,235,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(54,162,235,0.8)',
        hoverBorderColor: 'rgba(54,162,235,1)',
        data: [20, 25, 30, 35, 40, 45],
      },
      {
        label: 'Cash Payment',
        backgroundColor: 'rgba(75,192,192,0.6)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75,192,192,0.8)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: [25, 30, 35, 40, 45, 50],
      },
      {
        label: 'Other Payment',
        backgroundColor: 'rgba(153,102,255,0.6)',
        borderColor: 'rgba(153,102,255,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(153,102,255,0.8)',
        hoverBorderColor: 'rgba(153,102,255,1)',
        data: [10, 15, 20, 25, 30, 35],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
  };
  
  const handleFilter = (value) => {
    // console.log("value", value);
  } 

  return (
    <div
      className="no-flex-grow-card"
      style={{ flex: "1" }}
    >
      <div className="d-flex gap-1 align-items-center">
        <h1>Months Payment Details</h1>
        <CalendarComp view="month" handleFilter={handleFilter} />
      </div>
      <div
        className="chart-container  "
        style={{ position: "relative", height: "400px", width: "100%" }}
      >
        <Bar style={{ width: "50%" }} data={data} options={options} />
      </div>
    </div>
  );
};

export default MonthBarChart;
